module.exports = {
  width: '0.875rem',
  height: '0.875rem',

  focus: {
    boxShadow: {
      sizes: '0 0 0 3px',
      color: 'palette.primary',
    },
  },

  border: {
    radius: 'radius.md',

    color: {
      inactive: 'palette.secondaryAlt',
      checked: 'palette.primary',
      disabled: 'palette.secondary',
      error: 'palette.error',
      hover: 'palette.primary',
    },
  },
  background: {
    color: {
      inactive: 'palette.surfaceAlt',
      checked: 'palette.primary',
      disabled: 'palette.secondary',
      error: 'palette.error',
    },
  },
  icon: {
    padding: '2px 1px',
    color: {
      inactive: 'palette.surfaceAlt',
      checked: 'palette.surfaceAlt',
      disabled: 'palette.secondaryAlt',
      error: 'palette.surfaceAlt',
    },
  },
};
